import rimg from 'rimg-shopify'; // eslint-disable-line
import AsyncView from 'shopify-asyncview';
import ProductItem from '../components/ProductItem';

export default class StaticProductRecommendations {
  constructor(section) {
    this.section = section;
    this.productId = section.data.productId;
    this.limit = section.data.settings.limit;

    this.recommendationContainer = document.querySelector('[data-product-recommendations]');

    this.recommendUrl = `${window.Theme.routes.product_recommendations_url}?section_id=static-product-recommendations&limit=${this.limit}&product_id=${this.productId}`;

    this._loadRecommendations();
  }

  _loadRecommendations() {
    AsyncView.load(
      this.recommendUrl,
    ).done(({ html }) => {
      this.recommendationContainer.innerHTML = html;

      rimg.watch(this.recommendationContainer);

      const productEls = this.recommendationContainer.querySelectorAll('[data-product-item]');
      this.productItems = [];

      for (let i = 0; i < productEls.length; i++) {
        this.productItems.push(new ProductItem(productEls[i]));
      }

      if (window.Shopify && Shopify.PaymentButton) {
        Shopify.PaymentButton.init();
      }
    });
  }

  onSectionUnload() {
    this.productItems.forEach(product => product.unload());
  }
}
